import { action } from 'satcheljs';

export default action('ON_DISMISS_AUTOMATIC_REPLY_NOTIFICATION');
